import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import useLocalStorage from "@/hooks/useLocalStorage";
import { submitQuiz as submitQuizApi } from "@/services/apiQuiz";

export function useSubmitQuiz() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { courseId, grade, lectureId, attemptId, quizId } = useParams();
  const { removeLocalStorage, setLocalStorage } = useLocalStorage();

  const { isPending, mutate: submitQuiz } = useMutation({
    mutationKey: "quizAttemptDetails",
    mutationFn: submitQuizApi,
    retry: false,
    onSuccess: (data) => {
      removeLocalStorage(`quiz_${quizId}_results`);
      setLocalStorage(`quiz_${quizId}_results`, {
        data,
        timestamp: new Date().toISOString(),
        quizId,
        attemptId,
        courseId,
        lectureId,
      }, 1440);

      removeLocalStorage(`quiz_${attemptId}_answers`);

      toast.success("تم تسليم الأمتحان بنجاح");

      queryClient.removeQueries(["StartQuiz", courseId, lectureId, quizId]);

      navigate(
        `/${grade}/courses/${courseId}/lectures/${lectureId}/quiz/${quizId}/${attemptId}/results`,
        {
          replace: true,
          state: {
            data,
          },
        }
      );
    },

    onError: (error) => {
      toast.error("غير مسموح بتسليم نفس الأختبار مرتين");
      console.log(error.response.data);
    },
  });
  return { submitQuiz, isPending };
}
